import React, { useState, useEffect } from "react";

// api
import { getYears } from "../../api/pathsForHook/provider";
import useFetch from "../../hooks/useFetch";
// own hooks

// OWN COMPONENTS
import Select from "../select";

// constans

const SelectMonths = (props) => {
  const [options, setOptions] = useState([
    { value: "", name: "-- Selecciona un año --" },
  ]);
  const {methodGet} = useFetch()

  useEffect(() => {
    loadYear();
  }, []);

  const loadYear = async () => {
    const response = await methodGet(getYears());
    if (response) {
      const data = response.data.map((item) => ({
        value: item,
        name: item,
      }));
      const orderedYears = data.sort((a,b)=>a > b ? 1 : -1)
      setOptions(orderedYears);
      props.handleSelect(data[0].value);
    }
  };

  return <Select options={options} handleSelect={props.handleSelect} />;
};

export default SelectMonths;
